const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Deelnemende bedrijven ontvangen tegoeden in de vorm van een bonus op basis van de ingediende verkoopcijfers.",
};

export default {
  messages,
};
